import React from 'react';
import {
  Container,
  SecondWrapper,
  BlocWrapper,
} from 'containers/AmcDetailsPage/ServicesBlock/styles';
import ServicesBloc from 'containers/AMCDashboard/services/index';

const ServicesBlock = () => {
  return (
    <BlocWrapper height="212px">
      <Container padding={3}>
        <SecondWrapper container>
          <ServicesBloc mdGrid={12} smGrid={12} />
        </SecondWrapper>
      </Container>
    </BlocWrapper>
  );
};
export default ServicesBlock;
